import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'

export class AbortRequestService {
  private static instance: AbortRequestService
  private controller: AbortController

  private constructor() {
    this.controller = new AbortController()
  }

  // Return existing instance or create new
  public static getInstance(): AbortRequestService {
    if (!AbortRequestService.instance) {
      AbortRequestService.instance = new AbortRequestService()
    }
    return AbortRequestService.instance
  }

  // Return Abort Signal
  public getSignal(): AbortSignal {
    return this.controller.signal
  }

  // Abort request and create new AbortController instance
  public abortRequest(): void {
    this.controller.abort()
    this.controller = new AbortController()
  }
}
